import { render, staticRenderFns } from "./insuranceInfo.vue?vue&type=template&id=14b703fa&scoped=true&"
import script from "./insuranceInfo.vue?vue&type=script&lang=js&"
export * from "./insuranceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b703fa",
  null
  
)

export default component.exports